"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalPersonReferenceSchema = void 0;
exports.ExternalPersonReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/content/external-persons.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "ExternalPersonReference",
    "description": "A person who is not sponsored by Red Bull, but might still take part in a Red Bull competition or event.",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:master:external-persons"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZXh0ZXJuYWwtcGVyc29ucy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9yZWZlcmVuY2UvY29udGVudC9leHRlcm5hbC1wZXJzb25zLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLDZCQUE2QixHQUFHO0lBQzNDLEtBQUssRUFBRSxnRkFBZ0Y7SUFDdkYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUseUJBQXlCO0lBQ2xDLGFBQWEsRUFBRSwwR0FBMEc7SUFDekgsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTiw2QkFBNkI7YUFDOUI7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSw2RUFBNkU7U0FDekY7S0FDRjtDQUNGLENBQUEifQ==